module.exports = __webpack_public_path__ + "static/media/portal.b2a5f01a.webp";